import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { addNotificationAction } from '../../action/notifications/notifications';

import * as Api from '../../api/api';

export const createNotificationSetting = (
  params: NotificationSettingCreateRequest,
  opts: { showNotification: boolean } = { showNotification: true },
) =>
  createGenericDispatcher<{ result: NotificationSetting }>({
    name: 'CREATE_NOTIFICATION_SETTINGS',
    loadFunction: () =>
      Api.post('/notification-settings', {
        body: JSON.stringify(params),
      }),
    args: { params },
    onSuccess: opts.showNotification
      ? (dispatch) => {
          dispatch(
            addNotificationAction({
              key: `create-notification-setting-${params.username}-${params.notificationType}`,
              message: 'Updated notification setting.',
            }),
          );
        }
      : undefined,
  });
